"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createMenu;
function createMenu() {
    var fixture = init();

    function init() {
        return {
            items: [],
            chargesV2: []
        };
    }

    return {
        addChargeV2: function addChargeV2(charge) {
            fixture.chargesV2.push(charge);
            return this;
        },
        addItem: function addItem(item) {
            fixture.items.push(item);
            return this;
        },
        val: function val() {
            return fixture;
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-restaurants-js-sdk/dist/fixtures/Menu.js
// module id = 913
// module chunks = 0